import React from 'react';
import {
  McpOnly,
  OzOnly,
  PermsOnly,
  ReferralOnly,
  useCurrentProvider,
} from '../../../Components/Permissions';
import { MessageWidget } from '../../../Components/Widgets/MessageWidget';
import { Permission, useAdminUserMessagesQuery } from '../../../graphQL';
import { getFullName } from '../../../modelUtils/users';
import { CocExportWidget } from '../Widgets/CoCExport';
import { ContinuityOfCareEligibilitySlot } from '../Widgets/ContinuityOfCareEligibility';
import { MinorConsentNeeded } from '../Widgets/MinorConsent/MinorConsentNeeded';
import { UpcomingAppointmentWidgets } from '../Widgets/NextAppointmentWidget';
import { McpOnboarding, OzOnboarding, ReferralPortalOnboarding } from '../Widgets/Onboarding';
import { PatientAlertsWidgets } from '../Widgets/PatientActions';
import { ProviderTasks } from '../Widgets/ProviderTasks';
import { ScalesOverTime } from '../Widgets/ScalesOverTime';
import { Tasks } from '../Widgets/Tasks';
import { UserTimeline } from '../Widgets/Timeline';
import { UserNotifications } from '../Widgets/UserNotifications';
import { useDrilldownContext } from '../helpers';

export const OverviewTab = () => {
  const { currentProvider } = useCurrentProvider();
  const { user, setActiveTab } = useDrilldownContext();
  const { data, loading } = useAdminUserMessagesQuery({
    variables: { id: user.id },
    skip: !user.careFlows.some(cf => cf.provider?.id === currentProvider.id),
  });

  return (
    <div>
      <OzOnly>
        {user.careTypes.map(careType => (
          <ContinuityOfCareEligibilitySlot key={careType} careType={careType} slot="preNextSteps" />
        ))}
      </OzOnly>
      <PatientAlertsWidgets />
      <div className="mb3">
        <MessageWidget
          isLoading={loading}
          source={getFullName(user)}
          count={loading ? 0 : data?.adminUser.privateChannel.unreadMessageCount ?? 0}
          onClick={() => setActiveTab('messages')}
        />
      </div>
      <PermsOnly allowed={Permission.MantraAdmin}>
        <CocExportWidget />
      </PermsOnly>
      <MinorConsentNeeded user={user} />
      <UpcomingAppointmentWidgets />
      <OzOnly>
        <OzOnboarding />
      </OzOnly>
      <McpOnly>
        <McpOnboarding />
      </McpOnly>
      <ReferralOnly>
        <ReferralPortalOnboarding />
      </ReferralOnly>
      <OzOnly>
        <PermsOnly allowed={Permission.TicketView}>
          <ProviderTasks />
        </PermsOnly>
      </OzOnly>
      <OzOnly>
        {user.careTypes.map(careType => (
          <ContinuityOfCareEligibilitySlot
            key={careType}
            careType={careType}
            slot="postNextSteps"
          />
        ))}
      </OzOnly>
      <PermsOnly allowed={Permission.Phi}>
        <ScalesOverTime />
      </PermsOnly>
      <UserTimeline />
      <PermsOnly allowed={Permission.MantraAdmin}>
        <Tasks />
      </PermsOnly>
      <PermsOnly allowed={Permission.MantraAdmin}>
        <UserNotifications />
      </PermsOnly>
    </div>
  );
};
